import { render, staticRenderFns } from "./news_info.vue?vue&type=template&id=00b969ce&scoped=true"
import script from "./news_info.vue?vue&type=script&lang=js"
export * from "./news_info.vue?vue&type=script&lang=js"
import style0 from "./news_info.vue?vue&type=style&index=0&id=00b969ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b969ce",
  null
  
)

export default component.exports